// Function to create a dynamic heading element
// pass in "isSub" so it defaults to the correct heading
const createHeading = (tag, content, isSub) => {
    const defaultTag = isSub ? "h2" : "h1";
    const Tag = (tag || defaultTag).toLowerCase();
    const className = isSub ? "subtitle" : "title";
    return <Tag className={className}>{content}</Tag>;
}

export default createHeading;